// Global.js Fix - Patches the handleSubmit method to prevent formVariants.length error
// This must load BEFORE global.js executes the product-form definition

console.log('=== Global Fix Script Loaded ===');

// Override the customElements.define to intercept product-form registration
(function() {
  const originalDefine = customElements.define;
  
  customElements.define = function(name, constructor, options) {
    if (name === 'product-form') {
      console.log('Intercepting product-form definition to apply fix...');
      
      // Create a patched version of the constructor
      class PatchedProductForm extends constructor {
        constructor() {
          super();
          console.log('Product form constructor called - applying patches');
        }
        
        handleSubmit(evt) {
          console.log('Patched handleSubmit called');
          
          // Patch: Ensure quantityBreaks has formVariants before accessing
          if (this.quantityBreaks && !this.quantityBreaks.formVariants) {
            console.log('Adding missing formVariants to quantityBreaks');
            this.quantityBreaks.formVariants = [];
          }
          
          // Patch: Ensure bundleDeals has formVariants before accessing
          if (this.bundleDeals && !this.bundleDeals.formVariants) {
            console.log('Adding missing formVariants to bundleDeals');
            this.bundleDeals.formVariants = [];
          }
          
          // Patch: Ensure quantityGifts has unlockedItems before accessing
          if (this.quantityGifts && !this.quantityGifts.unlockedItems) {
            console.log('Adding missing unlockedItems to quantityGifts');
            this.quantityGifts.unlockedItems = [];
          }
          
          // Call the original handleSubmit
          try {
            super.handleSubmit(evt);
          } catch (error) {
            console.error('Error in handleSubmit:', error);
            console.log('Attempting fallback submit...');
            
            // Fallback: Basic form submission
            if (evt) {
              evt.preventDefault();
            }
            
            if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') {
              console.log('Submit button is disabled, aborting');
              return;
            }
            
            // Basic add to cart
            const formData = new FormData(this.form);
            const config = {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            };
            
            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
              formData.append('sections_url', window.location.pathname);
            }
            
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            
            fetch(window.routes.cart_add_url, config)
              .then(response => response.json())
              .then(response => {
                console.log('Fallback add to cart response:', response);
                if (response.status) {
                  console.error('Add to cart error:', response);
                  alert(response.message || 'Failed to add to cart');
                } else if (this.cart) {
                  this.cart.renderContents(response);
                } else {
                  window.location = window.routes.cart_url;
                }
              })
              .catch(error => {
                console.error('Fallback add to cart error:', error);
                alert('Failed to add to cart. Please try again.');
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                this.submitButton.removeAttribute('aria-disabled');
              });
          }
        }
      }
      
      // Register the patched version
      originalDefine.call(this, name, PatchedProductForm, options);
      console.log('Product-form registered with patches applied');
    } else {
      // For other custom elements, use the original define
      originalDefine.call(this, name, constructor, options);
    }
  };
  
  console.log('customElements.define interceptor installed');
})();
